/** Legende des Preiskalenders — kleine Punkte statt Kacheln, jede Farbe mit ihrem Wort (§11). */
import {
  DOUBLE_BOOKED_LABEL,
  DoubleBookedMark,
} from '@/features/properties/flat-family/DoubleBookedMark';
import { FAMILY_CLOSED_LABEL, formatShortRate } from './calendarHelpers';

export function CalendarLegend({
  currency,
  defaultRate,
  closedByFamily = false,
  doubleBooked = false,
}: {
  currency: string;
  defaultRate: number;
  closedByFamily?: boolean;
  doubleBooked?: boolean;
}) {
  return (
    <div className="text-ink-faint flex flex-wrap items-center gap-x-3 gap-y-1 pt-3 text-[11px]">
      <LegendItem
        marker={<span className="bg-line/50 size-1.5 rounded-full" aria-hidden />}
        label={`Standardpreis ${formatShortRate(defaultRate, currency)}`}
      />
      <Divider />
      <LegendItem
        marker={<span className="bg-sage/40 size-1.5 rounded-full" aria-hidden />}
        label="Belegt"
      />
      <Divider />
      <LegendItem
        marker={<span className="bg-sealwax/40 size-1.5 rounded-full" aria-hidden />}
        label="Verkaufsstopp"
      />
      {closedByFamily && (
        <>
          <Divider />
          <LegendItem
            marker={<span className="bg-postmark/30 size-1.5 rounded-full" aria-hidden />}
            label={FAMILY_CLOSED_LABEL}
          />
        </>
      )}
      {doubleBooked && (
        <>
          <Divider />
          <LegendItem marker={<DoubleBookedMark className="w-3" />} label={DOUBLE_BOOKED_LABEL} />
        </>
      )}
      <Divider />
      <LegendItem
        marker={<span className="bg-amber size-1.5 rounded-full" aria-hidden />}
        label="Vom Kanalmanager bestätigt"
      />
    </div>
  );
}

function LegendItem({ marker, label }: { marker: React.ReactNode; label: string }) {
  return (
    <span className="inline-flex items-center gap-1.5">
      {marker}
      {label}
    </span>
  );
}

function Divider() {
  return (
    <span className="text-ink-faint/60" aria-hidden>
      ·
    </span>
  );
}
